export const sgzMarkerDataSelector = ({sgzMarkerData}) => sgzMarkerData
